// extracted by mini-css-extract-plugin
export default {"container":"Subpage_container__m7yHV","content":"Subpage_content__00EyW"};